"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NoteIcon;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const useDevice_1 = require("../../../hooks/useDevice");
const colors_1 = require("../../../common/colors");
;
function NoteIcon({ isActive }) {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { colors: !isMobileScreen && ['transparent', 'transparent']
            || (isActive
                ? ['rgba(157, 237, 248, 0.40)', 'rgba(59, 149, 197, 0.40)']
                : ['rgba(157, 237, 248, 0.08)', 'rgba(59, 149, 197, 0.08)']), locations: [0.0479, 0.9512], useAngle: true, angle: 204, style: [styles.container, isMobileScreen && styles.containerMobile], children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: isActive ? pro_solid_svg_icons_1.faNoteSticky : pro_regular_svg_icons_1.faNoteSticky, color: isActive ? colors_1.Colors.white : colors_1.Colors.NEUTRAL_25, size: isMobileScreen ? 16 : 12 }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        padding: 2,
    },
    containerMobile: {
        padding: 8,
        borderRadius: 56,
    },
});
